import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col md:flex-row items-center">
            <div className="flex-1 p-6 md:p-10">
              <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-2">
                {appContent.title}
              </h2>
              <p className="text-lg md:text-xl text-foreground-600 font-medium mb-3">
                {appContent.subtitle}
              </p>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5">
                {appContent.description}
              </p>
              <div className="grid grid-cols-2 gap-2 mb-5">
                {appContent.features.map((f, i) => (
                  <div key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                    <i className="ri-check-line text-primary-500"></i>
                    <span>{f}</span>
                  </div>
                ))}
              </div>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap no-underline"
              >
                <i className="ri-smartphone-line"></i>
                立即体验移动端
              </a>
            </div>
            <div className="flex-shrink-0 p-4 md:p-0 md:pr-8">
              <img
                src={appContent.image}
                alt="菲菲影院移动端"
                className="w-[180px] md:w-[240px] h-auto object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}